import React from 'react'

import { HStack } from '~/components/elements/HStack'

import { type DocumentReport } from '../hooks/useDocumentReportsInfiniteQuery'

import { ArchiveButton } from './ArchiveButton'
import { CloneButton } from './CloneButton'
import { ShareButton } from './ShareButton'

export type CommandsCellProps = {
  dataItem: DocumentReport
}

export const CommandsCell = ({
  dataItem: documentReport,
}: CommandsCellProps) => (
  <td>
    <HStack backgroundColor="transparent" spacing={1}>
      <ShareButton documentReport={documentReport} />

      <CloneButton documentReport={documentReport} />

      <ArchiveButton documentReport={documentReport} />
    </HStack>
  </td>
)
